var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "show-game": _vm.showGame, "hide-game": !_vm.showGame },
      attrs: { id: "game-wrapper" }
    },
    [
      _c("canvas", {
        attrs: { oncontextmenu: "return false", id: "game-canvas" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }